import { render, staticRenderFns } from "./CollapseInput.vue?vue&type=template&id=1919f4df&scoped=true&"
import script from "./CollapseInput.vue?vue&type=script&lang=js&"
export * from "./CollapseInput.vue?vue&type=script&lang=js&"
import style0 from "./CollapseInput.vue?vue&type=style&index=0&id=1919f4df&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1919f4df",
  null
  
)

export default component.exports